// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
import { arrAppend, arrForEach, dumpObj } from "@nevware21/ts-utils";
import { _DYN_CALL, _DYN_LENGTH } from "../__DynamicConstants";
import { _throwInternal } from "../diagnostics/DiagnosticLogger";
var _maxHooks;
var _hookAddMonitor;
/**
 * Test hook for setting the maximum number of unload hooks and calling a monitor function when the hooks are added or removed
 * This allows for automatic test failure when the maximum number of unload hooks is exceeded
 * @param maxHooks - The maximum number of unload hooks
 * @param addMonitor - The monitor function to call when hooks are added or removed
 */
export function _testHookMaxUnloadHooksCb(maxHooks, addMonitor) {
    _maxHooks = maxHooks;
    _hookAddMonitor = addMonitor;
}
function _checkMaxHooks(name, hooks) {
    if (_maxHooks && hooks[_DYN_LENGTH /* @min:%2elength */] > _maxHooks) {
        _hookAddMonitor ? _hookAddMonitor(name, hooks) : _throwInternal(null, 1 /* eLoggingSeverity.CRITICAL */, 9948 /* _eInternalMessageId.MaxUnloadHookExceeded */, "Max unload hooks exceeded. An excessive number of unload hooks has been detected.");
    }
}
/**
 * Create a IUnloadHookContainer which can be used to remember unload hook functions to be executed during the component unloading
 * process.
 * @returns A new IUnloadHookContainer instance
 */
export function createUnloadHookContainer() {
    var _hooks = [];
    function _doUnload(logger) {
        var oldHooks = _hooks;
        _hooks = [];
        // Remove all registered unload hooks
        arrForEach(oldHooks, function (fn) {
            // allow either rm or remove callback function
            try {
                (fn.rm || fn.remove)[_DYN_CALL /* @min:%2ecall */](fn);
            }
            catch (e) {
                _throwInternal(logger, 2 /* eLoggingSeverity.WARNING */, 73 /* _eInternalMessageId.PluginException */, "Unloading:" + dumpObj(e));
            }
        });
        if (_maxHooks) {
            _checkMaxHooks("doUnload", oldHooks);
        }
    }
    function _addHook(hooks) {
        if (hooks) {
            arrAppend(_hooks, hooks);
            if (_maxHooks) {
                _checkMaxHooks("Add", _hooks);
            }
        }
    }
    return {
        run: _doUnload,
        add: _addHook
    };
}
//# sourceMappingURL=UnloadHookContainer.js.map